import { render, staticRenderFns } from "./CreatePost_80.vue?vue&type=template&id=4efc432c&"
import script from "./CreatePost_80.vue?vue&type=script&lang=js&"
export * from "./CreatePost_80.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports